import { match } from 'ts-pattern'
import { RegionViewModel } from 'functions/app/geography/view/region'
import { regionTabs } from '../constants'
import type { RegionFeatures } from '@schema/featureToggle'
import { isFeatureAvailable, isFeatureEnabled } from '@app/util/featureToggle'

export type RegionalLayoutTabAvailabilityContext = {
  expertsCount: number
}

export const isRegionalDiscussionEnabled = (
  region: RegionViewModel,
): boolean => isFeatureEnabled(region.featureToggles, regionTabs.discussion)

export const isRegionalLatestDiscussionsSectionAvailable = (
  region: RegionViewModel,
): boolean =>
  region.crowdbuildingPartner !== false && isRegionalDiscussionEnabled(region)

export const isRegionalLayoutTabAvailable = (
  region: RegionViewModel,
  tab: RegionFeatures,
  context: RegionalLayoutTabAvailabilityContext,
): boolean => {
  return match(tab)
    .with(regionTabs.overview, () => true)
    .with(regionTabs.discussion, () => isRegionalDiscussionEnabled(region))
    .with(regionTabs.initiatives, (matchedTab) =>
      isFeatureEnabled(region.featureToggles, matchedTab),
    )
    .with(regionTabs.municipalities, (matchedTab) =>
      isFeatureEnabled(region.featureToggles, matchedTab),
    )
    .with(regionTabs.current, (matchedTab) =>
      isFeatureAvailable(region.featureToggles, matchedTab, [
        region.stories,
        region.news,
        region.blogs,
      ]),
    )
    .with(
      regionTabs.experts,
      (matchedTab) =>
        isFeatureEnabled(region.featureToggles, matchedTab) &&
        context.expertsCount > 0,
    )
    .with(regionTabs.knowledgeHub, (matchedTab) =>
      isFeatureAvailable(region.featureToggles, matchedTab, [
        region.knowledgeHubModules,
      ]),
    )
    .otherwise(() => false)
}
